import { container } from "../../material-kit-react.jsx";

const footerStyle = {
  block: {
    color: "#a5d6a7",
    padding: "0.5rem 1rem",
    fontWeight: "500",
    fontSize: "13px",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block",
    transition: "color 0.2s ease",
    cursor: "pointer",
    "&:hover": {
      color: "#ffffff",
    },
  },
  footerExtra: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    padding: "0.5rem 0",
  },
  left: {
    float: "left!important",
    display: "block",
  },
  right: {
    padding: "15px 0",
    margin: "0",
    float: "right!important",
    color: "#a5d6a7",
    fontSize: "13px",
  },
  footer: {
    padding: "1.5rem 0",
    textAlign: "center",
    display: "flex",
    zIndex: "2",
    position: "relative",
    backgroundColor: "#1b5e20",
    color: "#ffffff",
    borderTop: "4px solid #2e7d32",
  },
  a: {
    color: "#81c784",
    textDecoration: "none",
    backgroundColor: "transparent",
    transition: "color 0.2s ease",
    "&:hover": {
      color: "#ffffff",
    },
  },
  footerWhiteFont: {
    "&,&:hover,&:focus": {
      color: "#FFFFFF",
    },
  },
  container: {
    ...container,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0",
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto",
  },
  icon: {
    width: "18px",
    height: "18px",
    position: "relative",
    top: "3px",
  },
};
export default footerStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/components/footerStyle.jsx